import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-gray-800 py-8 px-4" data-id="element-80">
      <div className="max-w-6xl mx-auto text-center" data-id="element-81">
        <p className="text-gray-400 text-sm mb-2" data-id="element-82">
          © 2024 Padel Smart Pro Elite. Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs" data-id="element-83">
          Producto digital - Acceso inmediato después de la compra
        </p>
      </div>
    </footer>;
}